import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../Components/LoginComp/firebase'; // Adjust the path to your firebase file

function PrivateRoute({ children }) {
  return auth.currentUser ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
